module.exports = __webpack_public_path__ + "img/vide1.8ee3ba0d.png";